import styled from '@emotion/styled';
import Link from 'next/link';

import { breakPoints } from 'constant/breakPoints';

import LogoSVG from './LogoSVG';
import {
  SOCIAL,
  CONTACT_PHONE,
  CONTACT_EMAIL,
  APP_ROUTES,
} from 'constant/appConstant';

function Footer(): JSX.Element {
  return (
    <Wrap className="layout-wrap">
      <Link href="/">
        <a>
          <LogoSVG />
        </a>
      </Link>

      <Contents className="footer-content">
        <div className="content-item bio">
          <h4 className="title2">Digital Solution Partner</h4>
          <p className="content-item-description font-medium text-gray2">
            We work with all of our dedication and experience to create the
            values and innovate the most advanced products.
          </p>
        </div>

        <div className="content-item">
          <h4 className="title2">Explore</h4>

          <p className="content-item-description font-medium text-gray2">
            <Link href={APP_ROUTES.SERVICES} prefetch={false}>
              <a>Services</a>
            </Link>
          </p>
          <p className="content-item-description font-medium text-gray2">
            <Link href={APP_ROUTES.BLOG} prefetch={false}>
              <a>Blog</a>
            </Link>
          </p>
          <p className="content-item-description font-medium text-gray2">
            <Link href={APP_ROUTES.CAREER} prefetch={false}>
              <a>Career</a>
            </Link>
          </p>
          <p className="content-item-description font-medium text-gray2">
            <Link href={APP_ROUTES.CONTACT_US} prefetch={false}>
              <a>Contact</a>
            </Link>
          </p>
          <p className="content-item-description font-medium text-gray2">
            <Link href={APP_ROUTES.LEGAL_PRIVACY} prefetch={false}>
              <a>Legal/Privacy</a>
            </Link>
          </p>
        </div>

        <div className="content-item contact">
          <div>
            <h4>
              <span className="title2">Ho Chi Minh City</span>
              <span className="typo1 text-gray2"> | Product Center</span>
            </h4>
            <p className="content-item-description font-medium text-gray2">
              <svg
                width="35"
                height="24"
                viewBox="0 0 35 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 22.75C11.6317 21.5829 10.3634 20.3033 9.20832 18.9248C7.47499 16.8545 5.41666 13.7713 5.41666 10.8333C5.41591 9.33288 5.86029 7.86592 6.69358 6.61811C7.52686 5.37031 8.71158 4.39775 10.0978 3.82352C11.484 3.24928 13.0095 3.09919 14.481 3.39224C15.9526 3.68528 17.3042 4.40828 18.3647 5.46975C19.0707 6.17268 19.6304 7.00867 20.0112 7.92932C20.392 8.84998 20.5865 9.83703 20.5833 10.8333C20.5833 13.7713 18.525 16.8545 16.7917 18.9248C15.6366 20.3033 14.3683 21.5828 13 22.75ZM13 7.58334C12.138 7.58334 11.3114 7.92575 10.7019 8.53524C10.0924 9.14473 9.74999 9.97138 9.74999 10.8333C9.74999 11.6953 10.0924 12.5219 10.7019 13.1314C11.3114 13.7409 12.138 14.0833 13 14.0833C13.8619 14.0833 14.6886 13.7409 15.2981 13.1314C15.9076 12.5219 16.25 11.6953 16.25 10.8333C16.25 9.97138 15.9076 9.14473 15.2981 8.53524C14.6886 7.92575 13.8619 7.58334 13 7.58334Z"
                  fill="#E8E8EA"
                />
              </svg>

              <span>
                16th Floor, 16 Nguyen Truong To Street, Ward 13, District 4, Ho
                Chi Minh City, Vietnam
              </span>
            </p>

            <p className="content-item-description font-medium text-gray2">
              <svg
                width="35"
                height="24"
                viewBox="0 0 35 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.6494 20C11.1184 20.012 4.64335 13.46 4.65235 5.003C4.65235 4.45 5.10035 4 5.65235 4H8.29235C8.78735 4 9.20835 4.364 9.28135 4.854C9.45546 6.02905 9.79727 7.17305 10.2964 8.251L10.3994 8.473C10.4685 8.62239 10.4834 8.79124 10.4414 8.95043C10.3994 9.10962 10.3032 9.24917 10.1694 9.345C9.35135 9.929 9.03935 11.104 9.67635 12.02C10.4754 13.17 11.4824 14.178 12.6324 14.977C13.5494 15.613 14.7244 15.301 15.3074 14.484C15.4031 14.3497 15.5427 14.2531 15.7022 14.211C15.8616 14.1688 16.0307 14.1836 16.1804 14.253L16.4014 14.355C17.4794 14.855 18.6234 15.197 19.7984 15.371C20.2884 15.444 20.6524 15.865 20.6524 16.361V19C20.6524 19.1314 20.6265 19.2615 20.5761 19.3829C20.5258 19.5043 20.4521 19.6146 20.3591 19.7075C20.2661 19.8003 20.1558 19.874 20.0343 19.9242C19.9129 19.9744 19.7828 20.0001 19.6514 20H19.6494Z"
                  fill="white"
                />
              </svg>

              <span>
                <a href={`tel:${CONTACT_PHONE.HREF}`}>{CONTACT_PHONE.LABEL}</a>
              </span>
            </p>

            <p className="content-item-description font-medium text-gray2">
              <svg
                width="35"
                height="24"
                viewBox="0 0 35 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.6523 8.608V16.75C22.6524 17.5801 22.3348 18.3788 21.7647 18.9822C21.1946 19.5856 20.4151 19.948 19.5863 19.995L19.4023 20H5.90234C5.07221 20.0001 4.27352 19.6824 3.67011 19.1123C3.06671 18.5422 2.70434 17.7628 2.65734 16.934L2.65234 16.75V8.608L12.3043 13.664C12.4117 13.7202 12.5311 13.7496 12.6523 13.7496C12.7736 13.7496 12.893 13.7202 13.0003 13.664L22.6523 8.608ZM5.90234 4H19.4023C20.2079 3.9999 20.9848 4.299 21.5824 4.83927C22.1799 5.37954 22.5555 6.12248 22.6363 6.924L12.6523 12.154L2.66834 6.924C2.74587 6.15431 3.09539 5.43752 3.65409 4.90246C4.21279 4.36741 4.94403 4.04919 5.71634 4.005L5.90234 4H19.4023H5.90234Z"
                  fill="white"
                />
              </svg>

              <span>
                <a href={`mailto:${CONTACT_EMAIL.HREF}`}>
                  {CONTACT_EMAIL.LABEL}
                </a>
              </span>
            </p>
          </div>

          <div>
            <h4>
              <span className="title2">Hong Kong</span>
              <span className="typo1 text-gray2"> | Head Office</span>
            </h4>
            <p className="content-item-description font-medium text-gray2">
              <svg
                width="35"
                height="24"
                viewBox="0 0 35 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 22.75C11.6317 21.5829 10.3634 20.3033 9.20832 18.9248C7.47499 16.8545 5.41666 13.7713 5.41666 10.8333C5.41591 9.33288 5.86029 7.86592 6.69358 6.61811C7.52686 5.37031 8.71158 4.39775 10.0978 3.82352C11.484 3.24928 13.0095 3.09919 14.481 3.39224C15.9526 3.68528 17.3042 4.40828 18.3647 5.46975C19.0707 6.17268 19.6304 7.00867 20.0112 7.92932C20.392 8.84998 20.5865 9.83703 20.5833 10.8333C20.5833 13.7713 18.525 16.8545 16.7917 18.9248C15.6366 20.3033 14.3683 21.5828 13 22.75ZM13 7.58334C12.138 7.58334 11.3114 7.92575 10.7019 8.53524C10.0924 9.14473 9.74999 9.97138 9.74999 10.8333C9.74999 11.6953 10.0924 12.5219 10.7019 13.1314C11.3114 13.7409 12.138 14.0833 13 14.0833C13.8619 14.0833 14.6886 13.7409 15.2981 13.1314C15.9076 12.5219 16.25 11.6953 16.25 10.8333C16.25 9.97138 15.9076 9.14473 15.2981 8.53524C14.6886 7.92575 13.8619 7.58334 13 7.58334Z"
                  fill="#E8E8EA"
                />
              </svg>

              <span>
                2nd Floor, Blink, 111 Bonham Strand Sheung Wan, Hong Kong
              </span>
            </p>
          </div>
        </div>

        <div className="content-item socials">
          <h4>Follow us</h4>

          <div>
            <a href={SOCIAL.FACEBOOK} target="_blank" rel="noreferrer">
              <img src="/images/icon/fb.svg" alt="Spirit labs services" />
              <img
                className="dark"
                src="/images/icon/fb-dark.svg"
                alt="Spirit labs services"
              />
            </a>

            <a href={SOCIAL.TWITTER} target="_blank" rel="noreferrer">
              <img src="/images/icon/twitter.svg" alt="Spirit labs services" />
              <img
                className="dark"
                src="/images/icon/twitter-dark.svg"
                alt="Spirit labs services"
              />
            </a>

            <a href={SOCIAL.LINKEDIN} target="_blank" rel="noreferrer">
              <img src="/images/icon/ln.svg" alt="Spirit labs services" />
              <img
                className="dark"
                src="/images/icon/ln-dark.svg"
                alt="Spirit labs services"
              />
            </a>
          </div>
        </div>
      </Contents>
    </Wrap>
  );
}

export default Footer;

const Wrap = styled.footer`
  padding-top: 50px;
  padding-bottom: 100px;

  .logo_svg {
    width: 272px;
    height: auto;
  }

  .typo1 {
    color: var(--gray2);

    a:hover {
      color: var(--white);
    }
  }

  .typo2 {
    font-weight: 500;
  }
`;

const Contents = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 48px;

  .content-item {
    margin-right: 43px;

    h4 {
      margin: 10px 0 24px;
      width: max-content;
    }

    p {
      margin-bottom: 12px;
    }

    &:last-of-type {
      margin-right: 0;
    }

    &-description {
      font-size: 14px;
    }

    &.socials {
      margin-right: 10px;

      > div {
        display: flex;
      }

      a {
        margin-right: 16px;

        &:last-of-type {
          margin-right: 0;
        }
      }
    }

    &.contact {
      /* max-width: 311px; */

      p {
        display: flex;
      }

      svg {
        min-width: 35px;
        color: var(--gray2);
      }

      & > div:last-of-type {
        margin-top: 50px;
      }
    }
  }

  @media screen and (min-width: ${breakPoints.tabletM}px) {
    /* flex-wrap: nowrap; */

    .content-item {
      margin-right: 43px;

      p {
        margin-bottom: 16px;
      }

      &-description {
        font-size: 16px;
      }

      &.contact {
        max-width: 311px;
      }

      &.socials {
        margin-right: 11px;
      }

      &.bio {
        max-width: 257px;
      }
    }
  }
`;
